// Badge: a short status word on its tone's faded fill (success, signal, warning, danger, accent),
// or muted (outlined). `spinner` shows work in progress. Ported from the Humint Assistant's
// components/ui/badge.tsx, sized like the board's tags.
import type { ComponentProps } from 'react';
import { cn } from './cn';
import { Spinner } from './Spinner';

export type BadgeTone = 'success' | 'signal' | 'warning' | 'danger' | 'muted' | 'accent';

const TONE: Record<BadgeTone, string> = {
  success: 'bg-success-faded text-success-ink',
  signal: 'bg-signal-faded text-signal-ink',
  warning: 'bg-warning-faded text-warning-ink',
  danger: 'bg-danger-faded text-danger-ink',
  muted: 'bg-transparent text-ink-muted border border-hairline',
  accent: 'bg-accent-faded text-accent-display',
};

export const badgeBase =
  'inline-flex h-[19px] items-center gap-1 whitespace-nowrap rounded-[5px] px-1.5 text-[11px] font-medium';

export interface BadgeProps extends ComponentProps<'span'> {
  tone?: BadgeTone;
  spinner?: boolean;
}

export function Badge({ tone = 'muted', spinner, className, children, ...props }: BadgeProps) {
  return (
    <span className={cn(badgeBase, TONE[tone], className)} {...props}>
      {spinner && <Spinner />}
      {children}
    </span>
  );
}
